export default __webpack_public_path__ + "829f7795f79a30ef92ed03d1a069580e.svg";